import { Theme, Typography, useMediaQuery } from '@mui/material';
import classnames from 'classnames';

import { CheckIcon } from 'assets';
import { HIPAA_BENEFITS } from 'constants/texts';

import styles from './RegisterLayout.module.scss';
import image from '../../assets/images/RegistrationLeftImage.png';
import girlImg from '../../assets/images/therapist.webp';

export type LeftSideType = '30DaysFree' | 'promo' | 'benefits';

type RegisterLayoutProps = {
  children: JSX.Element;
  leftSideType: LeftSideType;
  headers: string[];
  selectedHeader: number;
  leftSide?: JSX.Element | null;
  hideLeftSide?: boolean;
};

export function RegisterLayout({
  children,
  leftSide,
  leftSideType,
  headers,
  selectedHeader,
  hideLeftSide,
}: RegisterLayoutProps) {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.header}>
          {headers.map((title: string, index: number) => (
            <div
              key={index}
              className={classnames(styles.titleContainer, {
                [styles.titleContainerSelected]: selectedHeader > index,
                [styles.titleContainerNextSelected]: selectedHeader > index + 1 || selectedHeader === 3,
              })}
            >
              <div className={styles.titleContainerRound}>
                {!isMobile && <div className={styles.number}>{index + 1}</div>}
                <Typography variant={!isMobile ? 'body4' : 'body1'}>{title}</Typography>
              </div>
            </div>
          ))}
        </div>

        {/* ✅ Hide Left Side on Mobile */}
        {!isMobile && !hideLeftSide && leftSideType === 'benefits' && (
          <div className={styles.leftSideBenefits}>
            <img src={image} alt='Registration' />

            <Typography variant='h2' component='h2'>
              Welcome!
            </Typography>

            <Typography variant='h2' component='h2'>
              Benefits of HIPAA<span className={styles.link}>LINK</span>
            </Typography>

            <ul className={styles.dataText}>
              {HIPAA_BENEFITS.map((dataTextItem, index) => (
                <li key={index}>
                  <span className={styles.dataCheckIcon}>
                    <CheckIcon />
                  </span>

                  <Typography variant='body5' component='span'>
                    {dataTextItem}
                  </Typography>
                </li>
              ))}
            </ul>
          </div>
        )}

        {!isMobile && !hideLeftSide && leftSideType === '30DaysFree' && (
          <div className={styles.leftSide30DaysFree}>
            <Typography variant='h2' component='h2'>
              Get started with your
            </Typography>

            <Typography
              variant='h1'
              component='h1'
              sx={{
                margin: { xs: '-6px', sm: '-10px', md: '-12px' }, // Adjusts for mobile, tablet, and desktop
              }}
            >
              Free Trial Today!
            </Typography>

            <div className={styles.box}>
              <img src={girlImg} className={styles.girl} alt='User Testimonial' />

              <div className={styles.texts}>
                <Typography variant='body2' component='span' className={styles.comment}>
                  "HIPAA LINK has transformed my therapy practice — it's intuitive, secure, and makes connecting with
                  clients seamless. I finally have a platform that prioritizes both ease of use and HIPAA compliance."
                </Typography>

                <Typography variant='body4' component='span'>
                  Sarah Mitchell, LPC
                </Typography>

                <Typography variant='body4' component='span' color='#81CFDD'>
                  Mental Health Practitioner
                </Typography>
              </div>
            </div>
          </div>
        )}

        {!isMobile && !hideLeftSide && leftSideType === 'promo' && leftSide}

        <div className={styles.rightSide}>{children}</div>
      </div>
    </div>
  );
}
